<template>
  <nav-bar title="检查结果" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <div class="type-title">
      {{ messMess.ctitle
      }}<span style="font-size: 12px;color: #666;float: right">{{
        baseMess.crChecktime
      }}</span>
    </div>
    <div class="subject" v-for="item in list" :key="item.tid">
      <div class="subject-title">{{ item.tcontent }}</div>
      <van-field
        v-if="item.ttype === '1'"
        :rules="[{ required: true, message: '请选择答案' }]"
      >
        <template #input>
          <van-radio-group disabled v-model="item.result">
            <van-radio
              class="radio"
              v-for="radio in item.option"
              :key="radio.pid"
              :name="radio.pkey"
              >{{ radio.pname }}</van-radio
            >
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-else
        v-model="item.tcontent"
        disabled
        rows="2"
        autosize
        type="textarea"
        placeholder="请输入答案"
        :rules="[{ required: true, message: '请输入答案' }]"
      />
    </div>
    <div class="type-title">检查照片</div>
    <div class="img-container">
      <van-image
        width="100"
        height="100"
        class="img"
        v-for="item in picList"
        :key="item"
        fit="contain"
        :src="item"
      >
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
    </div>
    <div class="type-title">检查备注</div>
    <van-field
      v-model="baseMess.crRemark"
      disabled
      autosize
      type="textarea"
      placeholder="检查备注"
    />
    <Empty v-if="!list.length && !showLoading" description="暂无记录" />
  </Content>
</template>

<script>
import { ref } from 'vue'
import { getCheckResultInfoMess } from '@/api/salehome'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
export default {
  name: 'InspectionResults',
  props: ['crId'],
  setup(props) {
    const list = ref([])
    const baseMess = ref({})
    const messMess = ref({})
    const picList = ref([])
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      getCheckResultInfoMess,
      data => {
        baseMess.value = data.baseMess
        messMess.value = data.messMess
        list.value = data.infoList
        picList.value = data.picList
      },
      props.crId
    )
    getDataLoading()
    return {
      getDataLoading,
      showLoading,
      isLoading,
      list,
      baseMess,
      messMess,
      picList
    }
  }
}
</script>

<style lang="scss" scoped>
.type-title {
  padding: 16px;
  font-size: 16px;
  color: #000;
  font-weight: 600;
}
.img-container {
  background-color: #fff;
  padding: 16px;
  padding-left: 0;
  .img {
    margin-left: 16px;
  }
}
.subject {
  margin-bottom: 10px;
  .subject-title {
    padding: 16px;
    border-bottom: 1px solid #ccc;
    background-color: #fff;
    font-size: 14px;
    font-weight: 600;
  }
  .radio {
    padding: 10px 0;
  }
}
</style>
